import { FragmentParagraphContactInfoFragment } from '@/utils/drupal-api/__generated__/graphql';
import { BrandConfig } from 'types/brand-config';

import EmailIcon from '@/components/icon/email-icon';
import GlobeIcon from '@/components/icon/globe-icon';
import MapIcon from '@/components/icon/map-icon';
import PhoneIcon from '@/components/icon/phone-icon';

export type ContactInfoProps = {
  data: FragmentParagraphContactInfoFragment;
  className?: string;
  brand: BrandConfig;
  id?: string;
};

export const ContactInfo: React.FC<ContactInfoProps> = async ({
  data,
  className = 'self-start px-4 md:px-8 pb-8',
  brand,
  id,
}) => {
  return (
    <section className={`paragraph-contact-info ${className}`} id={id}>
      {(data.header || data.subHeader) && (
        <div className="pt-6">
          {data.header && <h2 className="h3">{data.header}</h2>}
          {data.subHeader && <h3 className="h5 mb-7">{data.subHeader}</h3>}
        </div>
      )}
      <ul className="flex flex-col gap-y-8">
        {brand.address && (
          <li className="flex items-center gap-x-6">
            <span className="w-6 text-gray-5">
              <MapIcon />
            </span>
            <address>
              <p>{brand.address.streetAddress}</p>
              <p>
                <span>{brand.address.city}</span>,&nbsp;
                <span>{brand.address.state}</span>&nbsp;
                <span>{brand.address.postalCode}</span>
              </p>
            </address>
          </li>
        )}
        {(brand.phone || brand.phoneTollFree) && (
          <li className="flex items-center gap-x-6">
            <span className="w-6 text-gray-5">
              <PhoneIcon className="w-5" />
            </span>
            <div className="space-y-3">
              {brand.phoneDisplay && (
                <p>
                  Direct:&nbsp;
                  <a
                    className="text-black-1 transition hover:text-link hover:no-underline"
                    href={`tel:${brand.phone}`}
                  >
                    {brand.phoneDisplay}
                  </a>
                </p>
              )}
              {brand.phoneTollFreeDisplay && (
                <p>
                  Toll free:&nbsp;
                  <a
                    className="text-black-1 transition hover:text-link hover:no-underline"
                    href={`tel:${brand.phoneTollFree}`}
                  >
                    {brand.phoneTollFreeDisplay}
                  </a>
                </p>
              )}
            </div>
          </li>
        )}
        {brand.email && (
          <li className="flex items-center gap-x-6">
            <span className="w-6 text-gray-5">
              <EmailIcon />
            </span>
            <a
              href={`mailto:${brand.email}`}
              target="_blank"
              className="p text-black-1 transition hover:text-link hover:no-underline"
            >
              {brand.email}
            </a>
          </li>
        )}
        {brand.canonicalHostname && (
          <li className="flex items-center gap-x-6">
            <span className="w-6 text-gray-5">
              <GlobeIcon />
            </span>
            <a
              href={`https://${brand.canonicalHostname}`}
              className="p text-black-1 transition hover:text-link hover:no-underline"
            >
              {`https://${brand.canonicalHostname}`}
            </a>
          </li>
        )}
      </ul>
    </section>
  );
};
